import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import DividasLogged from '../../../components/auth/divida'

function DividasLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Dividas Ativas" />
                <HeaderLogged />
                <Container>
                   <DividasLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default DividasLoggedScreen;